import { LinearProgress } from '@material-ui/core'
import React from 'react'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'

import Faq from './views/Common/Faq'
import Main from './views/Common/Main'
import Schedule from './views/Common/Schedule'
// import Signup from './views/Common/Signup'
import Login from './views/Common/Login'

import Admin from './views/Admin'
import Papers from './views/Admin/Papers'
import Paper from './views/Admin/Papers/details'
import SendReviews from './views/Admin/Reviews/send'
import Users from './views/Admin/Users'

import EvaluatorPapers from './views/Evaluator/Papers'
import EvaluatorPaper from './views/Evaluator/Papers/details'

import MyPapers from './views/Subscribed/MyPapers'
import MyPaper from './views/Subscribed/MyPapers/details'
import Profile from './views/Subscribed/Profile'

import Logout from './views/Authed/Logout'
import Subscribed from './views/Subscribed'


import rebase, { auth } from './config/rebase'
import { dbPrefix } from './Constants'
import { isSubscriptionAvailable, isSubscriptionForParticipantsAvailableAgain } from './utils'
import Finals from './views/Admin/Finals'
import Signup from './views/Common/Signup'
import SignupParticipantsOnly from './views/Common/SignupParticipantsOnly'
import Evaluator from './views/Evaluator'
import Reports from './views/Evaluator/Reports'

export default class Routes extends React.Component {
  state = { loaded: false }

  componentDidMount() {

    auth.onAuthStateChanged(async user => {
      // Se !auth
      if (!user) {
        return this.setState({
          isAuthenticated: !!user,
          user,
          loaded: true
        })
      }
      // Se admin
      if (user.email === 'mostra.curitibanos@ufsc.br') {
        return this.setState({
          isAuthenticated: !!user,
          user,
          admin: true,
          loaded: true
        })
      }
      // Se participante || apresentador || autor || mod
      const userDB = await rebase.fetch(dbPrefix + 'users', {
        asArray: true,
        queries: {
          orderByChild: "uEmail",
          equalTo: user.email
        }
      })

      return this.setState({
        isAuthenticated: !!user,
        user: userDB[0],
        loaded: true
      })
    })
  }

  render() {
    const AdminRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={props =>
          this.state.admin ? (
            <Component {...props} />
          ) : (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
          )
        }
      />
    )

    const EvaluatorRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={props =>
          this.state.user?.type === "5" ? (
            <Component {...props} user={this.state.user} />
          ) : (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
          )
        }
      />
    )

    const ModeratorRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={props =>
          this.state.user?.type === "4" ? (
            <Component {...props} user={this.state.user} />
          ) : (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
          )
        }
      />
    )

    const SubscribedRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={props =>
          this.state.isAuthenticated &&
            (this.state.user?.type === "2" || this.state.user?.type === "1") ? (
            <Component {...props} user={this.state.user} />
          ) : (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
          )
        }
      />
    )

    const CommonRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={props =>
          this.state.isAuthenticated ? (
            <Component {...props} user={this.state.user} />
          ) : (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
          )
        }
      />
    )

    const RedirectByType = () => {
      if (this.state.admin) {
        return <Redirect to={{ pathname: '/admin/home' }} />
      }
      if (this.state.user.type === "1" || this.state.user.type === "2") {
        return <Redirect to={{ pathname: '/home' }} />
      }
      if (this.state.user.type === "4") {
        return <Redirect to={{ pathname: '/mod/home' }} />
      }
      if (this.state.user.type === "5") {
        return <Redirect to={{ pathname: '/avaliador/home' }} />
      }
      return <Redirect to={{ pathname: "/" }} />
    }

    if (!this.state.loaded) {
      return <LinearProgress />
    }

    return (
      <BrowserRouter>
        <Switch>
          <Route exact path='/' component={Main} />
          <Route path='/mais/:tab?' component={Faq} />
          <Route path='/programacao' component={Schedule} />

          {/* controle */}
          {isSubscriptionAvailable() && <Route path='/inscreva-se' component={Signup} />}

          {isSubscriptionForParticipantsAvailableAgain() && <Route path='/inscreva-se' component={SignupParticipantsOnly} />}
          {
            this.state.isAuthenticated && this.state.user ?
              <Route path='/login' component={RedirectByType} />
              :
              <Route path='/login' component={Login} />
          }

          <AdminRoute path='/admin/home' component={Admin} />
          <AdminRoute path='/admin/users' component={Users} />
          <AdminRoute path='/admin/papers' component={Papers} />
          <AdminRoute path='/admin/ver-paper/:id' component={Paper} />
          <AdminRoute path='/admin/reviews' component={SendReviews} />
          {/* // ver review vai ser no paper */}

          <AdminRoute path='/admin/finalizacao' component={Finals} />

          <EvaluatorRoute path='/avaliador/home' component={Evaluator} />
          <EvaluatorRoute path='/avaliador/papers-para-avaliar' component={Reports} />
          <EvaluatorRoute path='/avaliador/ver-paper/:id' component={EvaluatorPaper} />

          <SubscribedRoute path='/home' component={Subscribed} />
          <SubscribedRoute path='/meu-perfil' component={Profile} />
          <SubscribedRoute path='/meus-trabalhos' component={MyPapers} />
          <SubscribedRoute path='/meu-trabalho/:id' component={MyPaper} />

          <CommonRoute path='/logout' component={Logout} />

          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    )
  }
}